export default {
  default: () => import("/root/workspace/ld_x_gw_Wdkc/layouts/default.vue"),
  ldh: () => import("/root/workspace/ld_x_gw_Wdkc/layouts/ldh.vue")
}